const circles3 = [
  {
    banner: {
      alt: "Best Sim Only Plans",
      src:
        "https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ecom/5+Plan+Mobile+Non-SAD+ecom+banner+v2%403x.png",
      style: {
        display: "none",
        margin: "auto"
      }
    },
    components: [
      {
        data: {
          step: 1,
          total_steps: 5
        },
        enable: true,
        name: "STEPPER"
      },
      {
        data: {
          title: "pre_checkout_text_1"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        condition: "!props.hidePlan",
        data: {
          dataBanners: "get(props, 'appSettings.banners.dataBanners')",
          hidePlanName: true,
          planBanners: "get(props, 'appSettings.banners.planBanners')",
          price_label: "total_data_for_monthly_price",
          promoBanners: "get(props, 'appSettings.banners.promoBanners')",
          toggle_label: "data_gb"
        },
        enable: true,
        name: "PAY_MONTHLY_DETAILS_CARD"
      },
      {
        condition:
          "get(props, 'payTodayItems.totalAmount') || !props.hidePayToday",
        data: {
          hideSelectedNumber: true
        },
        enable: true,
        name: "PAY_TODAY_SUMMARY_CARD"
      },
      {
        condition: "props.displayInternationalComms.incomingCalls",
        data: {
          options: [
            {
              label: "Yes",
              value: true,
              default: true
            },
            {
              label: "No",
              value: false
            }
          ]
        },
        enable: true,
        field: "allow_incoming_international_calls",
        label: "allow_incoming_international_calls_label",
        description: "allow_incoming_international_calls_description",
        name: "ALLOWING_INCOMING_OVERSEAS_CALL",
        required: true
      },
      {
        condition: "props.displayInternationalComms.incomingSMS",
        data: {
          options: [
            {
              label: "Yes",
              value: true,
              default: true
            },
            {
              label: "No",
              value: false
            }
          ]
        },
        enable: true,
        field: "allow_incoming_international_sms",
        label: "allow_incoming_international_sms_label",
        description: "allow_incoming_international_sms_description",
        name: "ALLOWING_INCOMING_OVERSEAS_SMS",
        required: true
      },
      {
        data: {
          monthlySummaryLabel: "total_data_for_price",
          next: {
            label: "next",
            path: "/circles3/new-number"
          },
          showMonthlySummary: true,
          stickyFooter: true
        },
        enable: true,
        name: "PAGE_NAVIGATION"
      }
    ],
    faqs: {
      faq: [
        {
          answer: "circles3_exceed_plan_answer",
          question: "exceed_plan_question"
        },
        {
          answer: "eligible_to_transfer_number_answer",
          question: "eligible_to_transfer_number_question"
        }
      ],
      title: "most_asked_questions"
    },
    name: "Pre-Checkout",
    path: "/circles3/pre-checkout"
  },
  {
    banner: {
      alt: "Best Sim Only Plans",
      src:
        "https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ecom/5+Plan+Mobile+Non-SAD+ecom+banner+v2%403x.png",
      style: {
        display: "none",
        margin: "auto"
      }
    },
    components: [
      {
        data: {
          step: 2,
          total_steps: 5
        },
        enable: true,
        name: "STEPPER"
      },
      {
        data: {
          subtitle: "new_number_text_2",
          title: "new_number_text_1"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        condition: "!props.portInOnlyMode",
        data: {
          field: "numberType",
          icons: {
            "new-number": {
              imageUrl:
                "https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ecom/2021+Icons/SG-NewNumber-Active.png",
              showOnlyWhenSelected: false
            },
            "number-transfer": {
              imageUrl:
                "https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ecom/2021+Icons/SG-NumberTransfer-Active.png",
              showOnlyWhenSelected: false
            }
          },
          items: [
            {
              default: true,
              href: "/circles3/keep-number",
              label: "transfer_number",
              name: "number-transfer",
              value: "port_in"
            },
            {
              href: "/circles3/new-number",
              label: "get_new_number",
              name: "new-number",
              value: "new_number"
            }
          ]
        },
        enable: true,
        name: "SWITCH_TOGGLE",
        type: "PILL"
      },
      {
        condition: "props.portInOnlyMode",
        data: {
          color: "#CC0046",
          content: "promo_code_only_applicable_for_number_transfer",
          mode: "transparent"
        },
        enable: true,
        name: "STATIC_CONTENT_BOX"
      },
      {
        condition: "!props.portInOnlyMode",
        data: {
          title: "your_new_number_is"
        },
        enable: true,
        name: "NEW_NUMBER_DISPLAY"
      },
      {
        condition: "!props.portInOnlyMode",
        data: {
          collapsed: false,
          initialItems: 6,
          see_less_text: "see_less_free_numbers",
          see_more_text: "see_more_free_numbers",
          title: "free_numbers"
        },
        enable: true,
        name: "GENERAL_NUMBER_SELECTION"
      },
      {
        data: {
          monthlySummaryLabel: "total_data_for_price",
          next: {
            disabled: "props.portInOnlyMode",
            label: "next",
            path: "/circles3/personal-details"
          },
          prev: {
            label: "go_back",
            path: "/circles3/pre-checkout"
          },
          showMonthlySummary: true,
          stickyFooter: true
        },
        enable: true,
        name: "PAGE_NAVIGATION"
      }
    ],
    name: "New Number",
    path: "/circles3/new-number"
  },
  {
    banner: {
      alt: "Seamless Number Transfer",
      src:
        "https://circles-marketing.s3-ap-southeast-1.amazonaws.com/au/ecommbanner+desktop+copy.png",
      style: {
        display: "none",
        margin: "auto"
      }
    },
    components: [
      {
        data: {
          step: 2,
          total_steps: 5
        },
        enable: true,
        name: "STEPPER"
      },
      {
        data: {
          subtitle: "port_in_number_text_2",
          title: "port_in_number_text_1"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        condition: "props.portInOnlyMode",
        data: {
          color: "#CC0046",
          content: "promo_code_only_applicable_for_number_transfer",
          mode: "transparent"
        },
        enable: true,
        name: "STATIC_CONTENT_BOX"
      },
      {
        condition: "!props.portInOnlyMode",
        data: {
          field: "numberType",
          icons: {
            "new-number": {
              imageUrl:
                "https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ecom/2021+Icons/SG-NewNumber-Active.png",
              showOnlyWhenSelected: false
            },
            "number-transfer": {
              imageUrl:
                "https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ecom/2021+Icons/SG-NumberTransfer-Active.png",
              showOnlyWhenSelected: false
            }
          },
          items: [
            {
              default: true,
              href: "/circles3/keep-number",
              label: "transfer_number",
              name: "number-transfer",
              value: "port_in"
            },
            {
              href: "/circles3/new-number",
              label: "get_new_number",
              name: "new-number",
              value: "new_number"
            }
          ]
        },
        enable: true,
        name: "SWITCH_TOGGLE",
        type: "PILL"
      },
      {
        condition: "!get(props, 'appSettings.enable_prepaid_port_in')",
        data: {
          regex: "generic.port_in_number.validation_regex",
          tooltip: "post_paid_number_field_tooltip"
        },
        enable: true,
        field: "post_paid_number",
        label: "port_in_your_current_post_paid_number",
        name: "POST_PAID_NUMBER",
        normalizer: {
          lookup: "generic.port_in_number",
          type: "NUMBER_WITH_MAX_LENGTH"
        },
        placeholder: "port_in_post_paid_number_placeholder",
        required: true,
        type: "number"
      },
      {
        condition: "get(props, 'appSettings.enable_prepaid_port_in')",
        data: {
          regex: "generic.port_in_number.validation_regex"
        },
        enable: true,
        field: "post_paid_number",
        label: "port_in_existing_number",
        name: "POST_PAID_NUMBER",
        normalizer: {
          lookup: "generic.port_in_number",
          type: "NUMBER_WITH_MAX_LENGTH"
        },
        placeholder: "port_in_post_paid_number_placeholder",
        required: true,
        type: "number"
      },
      {
        data: {
          display_count: 6
        },
        enable: true,
        field: "telco",
        label: "port_in_which_telco",
        name: "TELCO_LIST_RADIO",
        required: true
      },
      {
        condition: "get(props, 'appSettings.enable_prepaid_port_in')",
        data: {
          options: [
            {
              label: "postpaid",
              value: "postpaid",
              tooltip: "postpaid_description",
              tooltipBgColor: "#CED3FD",
              default: true
            },
            {
              label: "prepaid",
              value: "prepaid",
              tooltip: "prepaid_description",
              tooltipBgColor: "#CED3FD"
            }
          ]
        },
        disable_on_select: true,
        enable: true,
        field: "port_in_existing_plan_type",
        name: "PREPAID_POSTPAID_RADIO",
        label: "prepaid_or_postpaid_label",
        required: true
      },
      {
        data: {
          options: [
            {
              label: "Yes",
              value: true
            },
            {
              label: "No",
              value: false,
              tooltip: "registered_under_own_nric_id_no"
            }
          ]
        },
        enable: true,
        field: "registered_under_own_nric_id",
        label: "port_in_registered_under_own_nric",
        name: "REGISTERED_UNDER_OWN_NRIC",
        required: true
      },
      {
        condition:
          "formValues.registered_under_own_nric_id === 'false' && formValues.port_in_existing_plan_type !== 'prepaid'",
        data: { content: "port_in_registered_under_own_nric_tooltip" },
        enable: true,
        name: "STATIC_CONTENT_BOX"
      },
      {
        condition:
          "formValues.registered_under_own_nric_id === 'false' && formValues.port_in_existing_plan_type === 'prepaid'",
        data: { content: "port_in_registered_under_own_nric_tooltip_prepaid" },
        enable: true,
        name: "STATIC_CONTENT_BOX"
      },
      {
        condition: "formValues.port_in_existing_plan_type !== 'prepaid'",
        data: { content: "port_in_checklist" },
        enable: true,
        name: "STATIC_CONTENT_BOX"
      },
      {
        condition:
          "formValues.port_in_existing_plan_type === 'prepaid' && formValues.registered_under_own_nric_id !== 'false'",
        data: { content: "port_in_checklist_prepaid" },
        enable: true,
        name: "STATIC_CONTENT_BOX"
      },
      {
        data: {
          monthlySummaryLabel: "total_data_for_price",
          next: {
            disabled:
              "formValues.registered_under_own_nric_id === 'false' && formValues.port_in_existing_plan_type === 'prepaid'",
            label: "next",
            path: "/circles3/personal-details"
          },
          prev: {
            label: "go_back",
            path: "/circles3/pre-checkout"
          },
          showMonthlySummary: true,
          stickyFooter: true
        },
        enable: true,
        name: "PAGE_NAVIGATION"
      }
    ],
    faqs: {
      faq: [
        {
          answer:
            "<p>Don't terminate your line! Your line with your current telco will be automatically terminated after we've successfully transferred your number to Circles.Life.</p>",
          question: "Do I need to terminate my line with my current telco?"
        },
        {
          answer:
            "<p>We'll never charge you for transferring your number! However, we recommend checking with your current telco if any termination fees apply on their end.</p>",
          question: "Will I be charged a fee to transfer my number?"
        },
        {
          answer:
            "<p>If delivered before 1pm: Same day 11:30pm-2:00am. If delivered after 1pm: Next working day 11:30pm-2:00am.</p>",
          question: "When will the transfer of my number be complete?"
        },
        {
          answer:
            "<p>You may receive some service disruption, which is why we carry out the process late in the evening between 12:00am - 2:00am to avoid inconveniences to you.</p>",
          question:
            "Will there be any service disruption when my number is being transferred?"
        },
        {
          answer:
            "<p>Nothing! Just sit back and relax and we'll do the rest. We'll drop you messages via SMS and email to keep you updated along the way!</p>",
          question:
            "What should I do after submitting a request to transfer my number?"
        },
        {
          answer: "eligible_to_transfer_number_answer",
          question: "eligible_to_transfer_number_question"
        }
      ],
      title: "most_asked_questions"
    },
    name: "Port-In Number",
    path: "/circles3/keep-number",
    validations: [
      {
        async: true,
        field: "post_paid_number",
        lookup: "generic.contact_number",
        type: "port_in_number"
      },
      {
        field: "telco",
        message: "error_cannot_be_blank",
        type: "presence"
      },
      {
        field: "registered_under_own_nric_id",
        message: "error_cannot_be_blank",
        type: "presence"
      }
    ]
  },
  {
    banner: {
      alt: "Same Day Delivery ",
      src:
        "https://circles-marketing.s3-ap-southeast-1.amazonaws.com/au/ecommbanner+desktop+copy+2.png",
      style: {
        display: "none",
        margin: "auto"
      }
    },
    components: [
      {
        data: {
          step: 3,
          total_steps: 5
        },
        enable: true,
        name: "STEPPER"
      },
      {
        data: {
          subtitle: "personal_details_text_2",
          title: "personal_details_text_1"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        enable: true,
        field: "full_name",
        label: "personal_details_full_name",
        name: "TEXT_FIELD",
        placeholder: "personal_details_full_name_placeholder",
        required: true
      },
      {
        enable: true,
        field: "dob",
        label: "personal_details_date_of_birth",
        name: "DOB",
        required: true
      },
      {
        enable: true,
        field: "contact_number",
        label: "personal_details_contact_number",
        name: "CONTACT_NUMBER",
        placeholder: "personal_details_contact_number_placeholder",
        required: true
      },
      {
        enable: true,
        field: "email",
        label: "personal_details_email_to_send_bills",
        name: "TEXT_FIELD",
        placeholder: "personal_details_email_placeholder",
        required: true
      },
      {
        enable: true,
        field: "nationality",
        is_searchable: true,
        label: "personal_details_nationality",
        name: "NATIONALITY_DROPDOWN",
        required: true
      },
      {
        enable: true,
        field: "doc_type",
        label: "personal_details_id_type",
        name: "DOC_TYPE",
        required: true
      },
      {
        enable: true,
        field: "nric",
        label: "personal_details_nric",
        name: "TEXT_FIELD",
        normalizer: {
          type: "UPPERCASE"
        },
        placeholder: "personal_details_nric_placeholder",
        required: true
      },
      {
        condition: "get(props,'preCheckoutData.sim_type') !== 'esim' ",
        data: {
          checked_message: "personal_details_upload_id_later_checked_message",
          default: false,
          required: false
        },
        enable: false,
        field: "upload_id_later",
        label: "personal_details_i_choose_to_upload_my_id_later",
        name: "UPLOAD_ID_LATER"
      },
      {
        condition:
          "(!get(formValues, 'upload_id_later') && get(props,'preCheckoutData.sim_type') !== 'esim') ",
        data: {
          type: "primary"
        },
        label: "personal_details_upload_id",
        lookup: "documents.primary",
        name: "ID_UPLOADER",
        required: true
      },
      {
        condition: "get(props,'preCheckoutData.sim_type') === 'esim'",
        data: {
          title: "billing_address"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        condition: "get(props,'preCheckoutData.sim_type') === 'esim'",
        country: "sg",
        enable: true,
        field: "location",
        label: "delivery_info_enter_location",
        name: "GOOGLE_PREDICT_FIELD",
        type: "billing"
      },
      {
        condition: "get(props,'preCheckoutData.sim_type') === 'esim'",
        data: {
          prefix: "billing"
        },
        enable: true,
        field: "zip_code",
        label: "delivery_info_postal_code",
        name: "POSTAL_CODE"
      },
      {
        condition: "get(props,'preCheckoutData.sim_type') === 'esim'",
        enable: true,
        lookup: "profile.billing_address",
        name: "BILLING_ADDRESS_FORM"
      },
      {
        data: {
          monthlySummaryLabel: "total_data_for_price",
          next: {
            label: "next",
            path: "/circles3/delivery-info"
          },
          prev: {
            label: "go_back"
          },
          showMonthlySummary: true,
          stickyFooter: true
        },
        enable: true,
        name: "PAGE_NAVIGATION"
      }
    ],
    name: "Personal Details",
    path: "/circles3/personal-details",
    validations: [
      {
        field: "full_name",
        message: "error_please_fill_in_your_full_name",
        type: "presence"
      },
      {
        field: "full_name",
        message: "error_no_number_no_special_character",
        type: "alphabets_and_special_chars"
      },
      {
        field: "dob",
        message: "error_please_fill_in_your_date_of_birth",
        type: "presence"
      },
      {
        field: "dob",
        message: "error_invalid_date_of_birth",
        type: "regex",
        value: "^([0-2][0-9]|(3)[0-1])(-)(((0)[0-9])|((1)[0-2]))(-)\\d{4}$"
      },
      {
        field: "age",
        lookup: "profile.age_validation.min"
      },
      {
        field: "contact_number",
        message: "error_please_fill_in_your_contact_number",
        type: "presence"
      },
      {
        field: "contact_number",
        lookup: "generic.contact_number"
      },
      {
        field: "email",
        message: "error_please_fill_in_your_email_address",
        type: "presence"
      },
      {
        field: "email",
        message: "error_invalid_email",
        type: "email"
      },
      {
        field: "nationality",
        message: "error_please_fill_in_your_nationality",
        type: "presence"
      },
      {
        field: "doc_type",
        message: "error_please_fill_in_your_doc_type",
        type: "presence"
      },
      {
        field: "nric",
        message: "error_please_fill_in_your_nric",
        type: "presence"
      },
      {
        field: "nric",
        lookup: "documents.primary.types"
      }
    ]
  },
  {
    banner: {
      alt: "Same Day Delivery",
      src:
        "https://circles-marketing.s3-ap-southeast-1.amazonaws.com/au/ecommbanner+desktop+copy+2.png",
      style: {
        display: "none",
        margin: "auto"
      }
    },
    components: [
      {
        data: {
          step: 4,
          total_steps: 5
        },
        enable: true,
        name: "STEPPER"
      },
      {
        condition: "!props.uploadIDLater",
        data: {
          title: "delivery_info_text_1"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        condition: "!props.uploadIDLater && props.deliveryMethods.length > 1",
        data: {
          enabled_methods: ["home"]
        },
        enable: true,
        name: "DELIVERY_METHOD_PICKER"
      },
      {
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'home'",
        country: "sg",
        enable: true,
        field: "location",
        label: "delivery_info_enter_location",
        name: "GOOGLE_PREDICT_FIELD",
        type: "delivery"
      },
      {
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'home'",
        data: {
          prefix: "delivery"
        },
        enable: true,
        field: "zip_code",
        label: "delivery_info_postal_code",
        name: "POSTAL_CODE"
      },
      {
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'home'",
        lookup: "delivery.modes.home",
        name: "DELIVERY_ADDRESS_FORM_1"
      },
      {
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'instant_pick_up'",
        enable: false,
        lookup: "delivery.modes.instant_pick_up",
        name: "STORE_PICKER_1"
      },
      {
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'home'",
        data: {
          combined: false,
          field: "delivery_slot_full_data"
        },
        enable: true,
        label: "suggested_delivery_slots",
        name: "DELIVERY_DATE_PICKER"
      },
      {
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'home'",
        enable: true,
        field: "delivery_slot_full_data",
        name: "SPECIAL_DELIVERY_SLOT_PICKER"
      },
      {
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'home'",
        enable: true,
        field: "delivery_slot_full_data",
        name: "FREE_DELIVERY_SLOT_PICKER"
      },
      {
        data: {
          title: "billing_address"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'home'",
        enable: true,
        field: "same_as_delivery_address",
        label: "delivery_info_same_as_delivery_address",
        name: "BILLING_ADDRESS_SAME_AS_DELIVERY_ADDRESS"
      },
      {
        condition:
          "(props.uploadIDLater === true || formValues.same_as_delivery_address !== true || get(formValues, 'delivery_method.action') === 'instant_pick_up')",
        country: "sg",
        enable: true,
        field: "billing_location",
        label: "delivery_info_enter_location",
        name: "GOOGLE_PREDICT_FIELD",
        type: "billing"
      },
      {
        condition:
          "(props.uploadIDLater === true || formValues.same_as_delivery_address !== true || get(formValues, 'delivery_method.action') === 'instant_pick_up')",
        data: {
          prefix: "billing"
        },
        enable: true,
        field: "zip_code",
        label: "delivery_info_postal_code",
        name: "POSTAL_CODE"
      },
      {
        condition:
          "(props.uploadIDLater === true || formValues.same_as_delivery_address !== true || get(formValues, 'delivery_method.action') === 'instant_pick_up')",
        enable: true,
        lookup: "profile.billing_address",
        name: "BILLING_ADDRESS_FORM"
      },
      {
        data: {
          monthlySummaryLabel: "total_data_for_price",
          next: {
            label: "next",
            path: "/circles3/order-summary"
          },
          prev: {
            label: "go_back"
          },
          showMonthlySummary: true,
          stickyFooter: true
        },
        enable: true,
        name: "PAGE_NAVIGATION"
      }
    ],
    name: "Delivery Info",
    path: "/circles3/delivery-info",
    validations: [
      {
        field: "delivery_zip_code",
        lookup: "delivery.modes.home"
      },
      {
        field: "delivery_hse_blk_tower",
        lookup: "delivery.modes.home"
      },
      {
        field: "delivery_street_name",
        lookup: "delivery.modes.home"
      },
      {
        field: "delivery_unit_no",
        lookup: "delivery.modes.home"
      },
      {
        field: "delivery_building_name",
        key: "modes.home",
        lookup: "delivery"
      },
      {
        condition:
          "props.uploadIDLater || formValues.same_as_delivery_address !== true",
        field: "billing_zip_code",
        lookup: "delivery.modes.home"
      },
      {
        condition:
          "props.uploadIDLater || formValues.same_as_delivery_address !== true",
        field: "billing_hse_blk_tower",
        lookup: "delivery.modes.home"
      },
      {
        condition:
          "props.uploadIDLater || formValues.same_as_delivery_address !== true",
        field: "billing_street_name",
        lookup: "delivery.modes.home"
      },
      {
        condition:
          "props.uploadIDLater || formValues.same_as_delivery_address !== true",
        field: "billing_unit_no",
        lookup: "delivery.modes.home"
      },
      {
        condition:
          "props.uploadIDLater || formValues.same_as_delivery_address !== true",
        field: "billing_building_name",
        key: "modes.home",
        lookup: "delivery"
      },
      {
        field: "region",
        message: "error_cannot_be_blank",
        type: "presence"
      },
      {
        condition: "!formValues.delivery_slot_full_data",
        field: "post_office_id",
        message: "error_cannot_be_blank",
        type: "presence"
      },
      {
        field: "delivery_date",
        message: "error_cannot_be_blank",
        type: "presence"
      },
      {
        field: "delivery_slot_full_data",
        message: "error_cannot_be_blank",
        type: "presence"
      },
      {
        async: true,
        condition:
          "!props.uploadIDLater && get(formValues, 'delivery_method.action') === 'home'",
        field: "delivery_zip_code",
        lookup: "generic.zip_code",
        type: "postal_code"
      },
      {
        async: true,
        condition:
          "props.uploadIDLater || formValues.same_as_delivery_address !== true",
        field: "billing_zip_code",
        lookup: "generic.zip_code",
        type: "postal_code"
      }
    ]
  },
  {
    banner: {
      alt: "Last Step",
      src:
        "https://circles-marketing.s3.ap-southeast-1.amazonaws.com/ecom/5+Plan+Mobile+Non-SAD+ecom+banner+v2%403x.png",
      style: {
        display: "none",
        margin: "auto"
      }
    },
    components: [
      {
        data: {
          step: 5,
          total_steps: 5
        },
        enable: true,
        name: "STEPPER"
      },
      {
        data: {
          changeButton: {
            label: "change",
            url: "/circles3/pre-checkout"
          },
          title: "your_order"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        data: {
          details: [
            "full_name",
            "dob",
            "nric",
            "nationality",
            "contact_no",
            "contact_email",
            "billing_address"
          ],
          hideOrderRef: true,
          title: "order_summary_your_details"
        },
        enable: true,
        name: "ORDER_DETAILS_CARD"
      },
      {
        data: {
          hideBenefits: true,
          readonly: true,
          title: "promo_code_used"
        },
        enable: false,
        name: "PROMO_CODE_BOX"
      },
      {
        condition: "!props.hidePlan",
        data: {
          hidePlanName: true,
          planBanners: "get(props, 'appSettings.banners.planBanners')",
          price_label: "total_data_for_monthly_price",
          promoBanners: "get(props, 'appSettings.banners.promoBanners')"
        },
        enable: true,
        name: "PAY_MONTHLY_DETAILS_CARD"
      },
      {
        condition: "!props.hidePayToday",
        data: {
          hideSelectedNumber: false
        },
        enable: true,
        name: "PAY_TODAY_SUMMARY_CARD"
      },
      {
        condition: "!get(props, 'personalDetailFormsValues.upload_id_later')",
        data: {
          allowChange: true,
          showDeliveryDetails: true,
          showDeliveryTime: true,
          showOrderDetails: false,
          showPersonalDetails: true,
          title: "delivering_to"
        },
        enable: true,
        name: "DELIVERY_DETAILS_CARD"
      },
      {
        condition: "get(props, 'personalDetailFormsValues.upload_id_later')",
        data: {
          allowChange: true,
          showDeliveryDetails: false,
          showDeliveryTime: true,
          showOrderDetails: false,
          showPersonalDetails: true,
          title: "details"
        },
        enable: true,
        name: "DELIVERY_DETAILS_CARD"
      },
      {
        enable: true,
        name: "HR"
      },
      {
        data: {
          title: "payment_details"
        },
        enable: true,
        name: "PAGE_HEADER"
      },
      {
        condition: "props.validateOrderError",
        data: {
          alert: true,
          content: "order_summary_validate_order_failure_message",
          style: {
            backgroundColor: "transparent",
            color: "red"
          }
        },
        enable: true,
        name: "STATIC_CONTENT_BOX"
      },
      {
        condition: "!props.validateOrderError",
        enable: true,
        field: "terms_and_conditions_agreed",
        label: "order_summary_terms_terms_of_service_agreed",
        name: "TERMS_AND_CONDITIONS",
        required: true
      },
      {
        condition: "get(formValues, 'terms_and_conditions_agreed') === true",
        enable: true,
        name: "PAYMENT_FORM"
      },
      {
        data: {
          monthlySummaryLabel: "total_data_for_price",
          showMonthlySummary: true,
          stickyFooter: true
        },
        enable: true,
        name: "PAGE_NAVIGATION"
      }
    ],
    name: "Order Summary",
    path: "/circles3/order-summary"
  }
];

export default circles3;
